module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git1-3344ae37174e19b8f0c6601905577fbb.svg";